import React from "react";
import { useTranslation } from "react-i18next";
import "./services.css";

function Service() {
  const { t } = useTranslation();

  return (
    <section id="services"  className="services">
      <div className="container">
        <h2 className="section-title">{t("home.services.title")}</h2>
        <div className="services-grid">
          {["earlyOrtho", "teensBraces", "metalBraces", "clearAligners"].map(
            (service) => (
              <div key={service} className="service-card">
                <div className="service-icon">
                  {/* <img
                src={`/icons/${service}.svg`}
                alt={t(`home.services.${service}.title`)}
              /> */}
                  <img
                    src={t(`home.services.${service}.png`)}
                    alt={t(`home.services.${service}.title`)}
                  />
                </div>
                <h3>{t(`home.services.${service}.title`)}</h3>
                <p>{t(`home.services.${service}.description`)}</p>
              
                <a 
                  href="#contact" 
                  className="learn-more"
                  onClick={(e) => {
                    e.preventDefault();
                    const contactSection = document.getElementById('contact');
                    if (contactSection) {
                      const headerOffset = 15;
                      const elementPosition = contactSection.getBoundingClientRect().top;
                      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                      
                      window.scrollTo({
                        top: offsetPosition,
                        behavior: "smooth",
                      });
                    }
                  }}
                >
                  {t("home.services.learnMore")} →
                </a>
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
}

export default Service;
